import {
    buildSquaresDemoMatchOverPlaysResponse,
    buildSquaresDemoMyOversInMatch,
    buildSquaresDemoOverPlaysResponse,
    recordSquaresDemoSubmit,
    resetSquaresDemoState,
} from "./squaresDemoState";
import { buildSquaresDemoOddsGrid, isSquaresDemoMatchId } from "./squaresDemoMatchFixtures";

export { isSquaresDemoMatchId };

export function squaresDemoCalculateOverOdds(body: Record<string, unknown> | null | undefined) {
    const matchId = body?.matchId != null ? String(body.matchId) : "";
    if (!isSquaresDemoMatchId(matchId)) return null;
    return buildSquaresDemoOddsGrid();
}

export async function squaresDemoSubmit(
    _sessionToken: string,
    body: Record<string, unknown> | null | undefined,
    userAccount?: { id?: string; userId?: number; username?: string; player_name?: string; avatar?: string },
) {
    const matchId = body?.matchId != null ? String(body.matchId) : "";
    if (!isSquaresDemoMatchId(matchId)) return null;
    const selections = (body?.selections as Record<string, unknown>) ?? {};
    const overNumber = Number(body?.overNumber);
    const data = recordSquaresDemoSubmit(
        selections,
        userAccount,
        Number.isFinite(overNumber) ? overNumber : undefined,
    );
    return { ok: true, status: 200, data: { ...data, success: true } };
}

export function squaresDemoMatchOverPlays(searchParams: URLSearchParams) {
    const matchId = searchParams.get("matchId") ?? "";
    if (!isSquaresDemoMatchId(matchId)) return null;
    return Promise.resolve(buildSquaresDemoMatchOverPlaysResponse());
}

export function squaresDemoOverPlays(searchParams: URLSearchParams) {
    const matchId = searchParams.get("matchId") ?? "";
    if (!isSquaresDemoMatchId(matchId)) return null;
    const overNum = parseInt(searchParams.get("overNumber") ?? "", 10);
    let ballResults: string[] | null = null;
    const raw = searchParams.get("ballResults");
    if (raw) {
        try {
            const parsed = JSON.parse(raw);
            ballResults = Array.isArray(parsed) ? parsed.map(String) : null;
        } catch {
            ballResults = null;
        }
    }
    return Promise.resolve(buildSquaresDemoOverPlaysResponse(overNum, ballResults));
}

export function squaresDemoMatchSocial() {
    return Promise.resolve({ friends_on_over: [], challenges: [] });
}

export function squaresDemoMyOversInMatch(
    _sessionToken: string,
    query: { matchId?: string; inningsNumber?: number },
    viewerUserId?: string | number | null,
) {
    if (!isSquaresDemoMatchId(query?.matchId)) return null;
    return Promise.resolve(buildSquaresDemoMyOversInMatch(viewerUserId));
}

export function squaresDemoTrySettleOver() {
    return Promise.resolve({ ok: true });
}

export function resetSquaresDemoSession() {
    resetSquaresDemoState();
}
